import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonpropertiesService } from '../services/commonproperties.service';
import { GetDataService } from '../services/get-data.service';
import { ActionService } from '../services/action.service';

@Component({
  selector: 'lib-complex-element',
  templateUrl: './complex-element.component.html',
  styleUrls: ['./complex-element.component.css']
})
export class ComplexElementComponent implements OnInit {

  @Input() isHeader: any;
  @Input() isHeaderChild: any;
  @Input() jsonObject: any;
  @Input() layoutObject: any;
  @Input() complexElementBeanClass: string;
  complexLoading: boolean = false;
  serviceUnavailable: boolean = false;
  headerFlag = false;
  enableReload = false;
  isServiceDown;
  isComplexOpen: boolean = true;
  interval;
  @Output() clickEvent = new EventEmitter();

  constructor(private _getDataService: GetDataService, private commonProp: CommonpropertiesService, private action: ActionService) { }

  ngOnInit() {

    if (this.jsonObject.hasOwnProperty('displayName') && this.jsonObject['displayName'] != "") {
      this.isComplexOpen = true;
    }

    if (this.jsonObject['type'] == 'header') {
      this.commonProp.headerFlag = true;
      this.headerFlag = true;
    }

    if (this.jsonObject['beanClass'] != undefined && this.jsonObject['beanClass'] != '') {
      this.commonProp.complexElementBeanClass = this.jsonObject['beanClass'];
    } else {
      this.commonProp.complexElementBeanClass = undefined;
    }

    if (this.jsonObject['isAjax'] && (this.jsonObject['isAjax'] && this.jsonObject['ajaxCall'] && this.jsonObject['ajaxCall']['ajaxEvent'] == 'onLoad')) {
      var _self = this;
      _self.complexLoading = true;
      _self.serviceUnavailable = false;
      _self.enableReload = true;

      let componentEndPointURL = _self.jsonObject['ajaxCall']['componentEndPointURL'];
      let dataEndPointURL = _self.jsonObject['ajaxCall']['dataEndPointURL'];

      _self._getDataService.getComponentDetails(componentEndPointURL, dataEndPointURL).subscribe(data => {
        _self.jsonObject['elements'] = data['responseMap']['ScreenJson']['elements'];
        if (data['responseMap'] && data['responseMap']['ValueJson']) {
          _self.action.triggerValueJSONUpdate(data);
        }

        _self.complexLoading = false;
        _self.serviceUnavailable = false;
        _self.isServiceDown = false;
        //dynamicHeightLogic();
      },
        error => { // error path
          _self.isServiceDown = true;
          _self.serviceUnavailable = true;
          _self.complexLoading = false;
          // dynamicHeightLogic();
        })
    }
  }

  eventReceive(obj) {
    console.log('Event received in simple and emitted to complex : ' + obj);
    this.clickEvent.emit(obj);
  }

}
